import {Component, Input, Output, EventEmitter} from '@angular/core';
import { ColumnSettingsItem } from '../column-settings/column-settings.component';
import { FilterSettingsItem } from '../filter-settings/filter-settings.component';
import { TableConfig } from '../../../models/table-config.interface';
import { ButtonsConfig, DropdownMenuItem } from '../../../models/button.interface';

@Component({
  selector: 'pv-custom-list-layout',
  templateUrl: './custom-list-layout.component.html',
  styleUrls: ['./custom-list-layout.component.scss']
})
export class CustomListLayoutComponent implements TableConfig {

  @Input() title?: string;
  @Input() hideTitle?: boolean = false;
  @Input() hideTabs?: boolean = false;
  @Input() hideFilters?: boolean = false;
  @Input() hideInfos?: boolean = false;
  @Input() storageKey: string = 'default';

  @Input() showColumnSettings: boolean = false;
  @Input() columnSettings: ColumnSettingsItem[] = [];

  @Input() showFilterSettings: boolean = false;
  @Input() filterSettings: FilterSettingsItem[] = [];

  @Input() buttonsConfig: ButtonsConfig = {
    import: undefined,
    exportAll: undefined,
    export: undefined,
    refresh: undefined,
    clearFilters: undefined
  };

  // Event emitters
  @Output() columnVisibilityChanged = new EventEmitter<ColumnSettingsItem[]>();
  @Output() filterVisibilityChanged = new EventEmitter<FilterSettingsItem[]>();
  @Output() exportClicked = new EventEmitter<void>();
  @Output() exportAllClicked = new EventEmitter<void>();
  @Output() importClicked = new EventEmitter<void>();
  @Output() refreshClicked = new EventEmitter<void>();
  @Output() dropdownMenuItemClicked = new EventEmitter<DropdownMenuItem>();
  @Output() clearFiltersClicked = new EventEmitter<void>();

  // Event handlers
  onColumnVisibilityChanged(columnSettings: ColumnSettingsItem[]) {
    this.columnVisibilityChanged.emit(columnSettings);
  }

  onFilterVisibilityChanged(filterSettings: FilterSettingsItem[]) {
    this.filterVisibilityChanged.emit(filterSettings);
  }

  onExportClicked() {
    this.exportClicked.emit();
  }

  onExportAllClicked() {
    this.exportAllClicked.emit();
  }

  onImportClicked() {
    this.importClicked.emit();
  }

  onRefreshClicked() {
    this.refreshClicked.emit();
  }

  onDropdownMenuItemClicked(menuItem: DropdownMenuItem) {
    this.dropdownMenuItemClicked.emit(menuItem);
  }

  onClearFiltersClicked() {
    this.clearFiltersClicked.emit();
  }
}
